<template>
  <div class="container">
    <div v-for="(item, index) in settingList">
      <SettingItem :item="item"/>
    </div>
  </div>
</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import SettingItem from '@/components/widgets/SettingItem'
import app from '@/AppData'
import Constants from '@/components/setting/Constants'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'
import util from '@/utils/util'

const PROLOGUE_CUSTOM_STORAGE_KEY = 'PROLOGUE_CUSTOM_STORAGE_KEY'

export default {
  name: 'VipProloguePage',

  components: {
    SettingItem
  },

  data () {
    let that = this

    let obj = Constants.getPrologueChecked()

    var customPrologue = null
    if (obj.customChecked === true) {
      customPrologue = app.getData().userCustomContent.firstTalk
    } else {
      customPrologue = app.getLocalStorage(PROLOGUE_CUSTOM_STORAGE_KEY)
    }
    return {
      settingList: [
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.8,
        },
        {
          icon: '@/../static/prologue_default_icon.png',
          title: '默认版',
          desc: '您好，我是机主的助理，请问您是哪位？',
          isChecked: true,
          checked: obj.defaultChecked,
          isDefault: true,
          onClick: function () {
            console.log(this.title)
            that.onRadioClick(this)
          },
          onRadioClick () {
            that.onRadioClick(this)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/prologue_business_icon.png',
          title: '商务版',
          desc: '您好，我是机主的助理，他现在在忙，不方便接电话，请问您是哪位？',
          isChecked: true,
          checked: obj.businessChecked,
          onClick: function () {
            console.log(this.title)
            that.onRadioClick(this)
          },
          onRadioClick () {
            that.onRadioClick(this)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/prologue_custom_icon.png',
          title: '自定义内容',
          desc: that.formatContent(customPrologue),
          rawDesc: customPrologue,
          emptyDesc: '输入助理要说的话',
          isChecked: true,
          checked: obj.customChecked,
          isCustom: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              // 使用params传递参数时，必须用name，不能用path
              name: 'vip_prologue_edit_page',
              params: {
                value: customPrologue
              }
            })
          },
          onRadioClick () {
            that.onRadioClick(this)
          }
        }
      ]
    }
  },

  methods: {
    formatContent (firstTalk) {
      if (!util.isEmpty(firstTalk)) {
        var result = firstTalk.length > 30 ? (firstTalk.substr(0, 30) + '...') : firstTalk
        return result
      } else {
        return ''
      }
    },

    onRadioClick (item) {
      console.log('onRadioClick, item:' + JSON.stringify(item))
      if (item.isCustom && !item.desc) {
        // 点击了自定义，而且没内容，跳转自定义编辑
        this.$router.push({
          path: '/vip_prologue_edit_page'
        })
        lubanapi.reportseer('AICall_Opening_Remarks_Setting_Page_Customize_Edition_Edit_Button_Click', app.isVip() ? '1' : '0')
        return
      }
      lubanapi.reportseer('AICall_Opening_Remarks_Setting_Page_Switch_Operation', app.isVip() ? '1' : '0')
      if (item.checked) {
        // 已经选中了
        return
      }
      if (!app.isVip()) {
        // 非会员，弹窗
        jsbridge.showVipGuideDialog(this)
        return
      }
      // 先刷新UI
      this.settingList.forEach(it => {
        it.checked = false
      })
      item.checked = true
      let content = item.desc
      if (item.isCustom === true && item.rawDesc) {
        content = item.rawDesc
      }
      if (item.isDefault) {
        content = ''
      }
      app.setUserCustomContent({firstTalk: content})
      app.reportCustomContent().then(value => {
        console.log('reportCustomContent success')
      }, reason => {
        console.log('reportCustomContent fail, reason:' + JSON.stringify(reason))
      })
    }
  },

  mounted () {
    TitleBarStore.store.showvipicon()
    lubanapi.reportseer('AICall_Opening_Remarks_Setting_Page_Shown', app.isVip() ? '1' : '0')
  }
}

</script>

<style scoped>


.container {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;
}

</style>



// WEBPACK FOOTER //
// src/components/setting/VipProloguePage.vue